import { generateUnOrderedList } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const FigureDesc51 = {
    item: "Figure 51: Typical floor plan for a 1-Person Office Space.",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The floor plan depicts a one-person office space with an entrance at the bottom-right of the layout. The features of the space are described from bottom to the top.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The entrance to the single-person workspace is provided at the bottom-right corner of the plan.",
                    "To the left of the room, a desk is provided with a chair for the administrative officer on one side, facing the entrance, and two chairs for visitors on the other side.",
                    "The desk is equipped with digital technology, including computer systems.",
                    "Storage is provided at the top of the layout, along the wall, at a distance of 950 mm from the administrative officer’s seating.",
                    "The room is accessible, with space measuring 1500 mm x 1050 mm between the desk and the right side of the room and a turning diameter of 1500 mm.",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc52 = {
    item: "Figure 52: Typical floor plan for a 6-Person Office Space. ",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The floor plan depicts a 6-person office space (7300 mm x 4800 mm) with an entrance at the bottom-right of the layout. The features of the space are described from bottom to the top.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The entrance to the room is provided at the bottom-right. The entrance is accessible, with a turning diameter of 1500 mm.",
                    "In the centre of the room, a large desk, divided into six separate workstations, is provided. The desk is equipped with digital technology, including computer systems.",
                    "Six chairs have been provided for seating at each of these workstations, including wheelchair-accessible seating.",
                    "Storage facilities are provided along the wall at the top and left of the layout.",
                    "At the top-right, xerox facilities are provided.",

                ])}
            </div>
        </p>
    </>
}

